/**
 * WIR Franc.
 */
export var CHW = {
  code: 'CHW',
  base: 10,
  exponent: 2
};